<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "App",
};
</script>

<style>
* {
  padding: 0;
}
html,
body {
  height: 100%;
  margin: 0;
}
</style>
